/*global Daon */
/*eslint no-undef: "error"*/

import React from "react"

import "./style.css"

import packageJson from "../../../package.json"

export const version = packageJson.version;

let _versionInfo = `Demo Version: ${version} \n`;
if (global.DAON_BUILD_VERSION && !global.DAON_BUILD_VERSION.includes("@")) _versionInfo += `(build version: ${global.DAON_BUILD_VERSION}) \n`

if (global.Daon) {
  if (Daon.FaceCapture && Daon.FaceCapture.VERSION) _versionInfo += `FaceCapture: ${Daon.FaceCapture.VERSION} \n`;
  if (Daon.DocumentCapture && Daon.DocumentCapture.VERSION) _versionInfo += `DocumentCapture: ${Daon.DocumentCapture.VERSION} \n`;
  if (Daon.CLRCapture && Daon.CLRCapture.VERSION) _versionInfo += `CLRCapture: ${Daon.CLRCapture.VERSION} \n`;
  if (Daon.FaceLiveness3D && Daon.FaceLiveness3D.VERSION) _versionInfo += `FaceLiveness3D: ${Daon.FaceLiveness3D.VERSION} \n`;
}

export function Version() {
  return <span
    role="img"
    className="app-version"
    aria-label="version info"
    title={_versionInfo}
    onClick={() => alert(_versionInfo)}>ℹ️</span>
}

export const versionInfo = _versionInfo;

export default Version;